<template>
  <div class="relative" ref="containerRef">
    <div class="sticky-wrapper">
      <div class="absolute-image-container">
        <img
          v-if="selectedIndex === 0"
          style="max-height: 784px"
          class="w-full h- md:h-full object-cover"
          :src="require('@/assets/bgs/daoByTreasury.png')"
          alt=""
        />
        <img
          v-if="selectedIndex === 1"
          class="w-full h- md:h-full object-cover"
          :src="require('@/assets/bgs/daoByGovernance.png')"
          alt=""
        />
      </div>
    </div>
    <div
      class="
        md:flex
        justify-end
        gap-6
        z-10
        relative
        px-4
        md:px-0
        mx-auto
        max-w-1200px
      "
    >
      <el-affix
        :class="{ sidebar: affixEnabled, sidebar_exit: !affixEnabled }"
        v-if="isDesktop"
        :offset="144"
      >
        <div style="width: 282px; min-width: 282px" class="z-10 relative">
          <div
            v-for="(option, i) in options"
            :key="i"
            class="relative cursor-pointer option mb-4"
            :class="{ option_selected: selectedIndex === i }"
            @click="() => selectTab(i)"
          >
            <div
              v-if="selectedIndex === i"
              class="absolute w-1 h-full left-0 top-0"
              style="
                background: linear-gradient(315deg, #ff5585 0%, #268cff 100%);
              "
            ></div>
            <div class="px-4 py-2.5">
              <div
                v-if="selectedIndex === i"
                class="text-xl font-bold text-whitebase"
              >
                {{ option.title }}
              </div>
              <div v-else class="text-xl font-bold text-white-080">
                {{ option.title }}
              </div>
              <div class="text-white-080 text-base">
                {{ option.subtitle }}
              </div>
            </div>
          </div>
        </div></el-affix
      >
      <div v-else style="width: 209px; min-width: 209px" class="z-10 relative">
        <el-dropdown class="w-full mb-3">
          <div class="flex justify-between w-full">
            <div class="relative w-full cursor-pointer option_selected">
              <div
                class="absolute w-1 h-full left-0 top-0"
                style="
                  background: linear-gradient(315deg, #ff5585 0%, #268cff 100%);
                "
              ></div>
              <div class="px-2 py-2">
                <div class="text-whitebase text-base font-bold">
                  {{ options[selectedIndex].title }}
                </div>
                <div class="text-white-080 text-xs">
                  {{ options[selectedIndex].subtitle }}
                </div>
              </div>
            </div>
            <div class="mt-2 text-whitebase icon iconfont icon-xia1"></div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                :divided="i > 0"
                v-for="(option, i) in options"
                :key="i"
                class="relative cursor-pointer option"
                :class="{ option_selected: selectedIndex === i }"
                @click="() => selectTab(i)"
              >
                <div class="px-2 py-2">
                  <div class="text-sm font-bold">{{ option.title }}</div>
                  <div class="text-white-080 text-xs">
                    {{ option.subtitle }}
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div style="max-width: 894px">
        <!-- <div
          v-if="isDesktop"
          class="text-base text-white-080 py-2 px-4 mb-4 bg-white-040 rounded"
        >
          <div>
            {{ textList[selectedIndex].mainText }}
          </div>
          <div
            class="font-bold pt-2"
            v-if="textList[selectedIndex].formulaText"
          >
            {{ textList[selectedIndex].formulaText }}
          </div>
          <div v-if="textList[selectedIndex].endText">
            {{ textList[selectedIndex].endText }}
          </div>
        </div> -->
        <SeeMoreTextDialog
          :reset-show="selectedIndex"
          :text="textList[selectedIndex]"
        />
        <DaoByTreasury v-if="selectedIndex === 0" />
        <DaoByGovernance v-else-if="selectedIndex === 1" />
        <Infrastructure v-else-if="selectedIndex === 2" />
        <PersonOfTheYear v-else-if="selectedIndex === 3" />
        <NewFrontierDao v-else-if="selectedIndex === 4" />
      </div>
    </div>
  </div>
</template>
<script setup>
import {
  ref,
  onMounted,
  watch,
  onUnmounted,
  nextTick,
  onUpdated,
  onActivated,
} from 'vue';
import DaoByTreasury from './DaoByTreasury.vue';
import DaoByGovernance from './DaoByGovernance.vue';
import Infrastructure from './Infrastructure.vue';
import NewFrontierDao from './NewFrontierDao.vue';
import PersonOfTheYear from './PersonOfTheYear.vue';
import SeeMoreTextDialog from './SeeMoreTextDialog.vue';
import { useRoute, useRouter } from 'vue-router';
import { useDesktop } from '@/hooks';

const containerRef = ref(null);
const affixEnabled = ref(true);

const checkAffix = () => {
  if (!containerRef.value) return;

  const containerBottom = containerRef.value.getBoundingClientRect().bottom;
  const viewportHeight = window.innerHeight;

  affixEnabled.value = containerBottom + 100 > viewportHeight;
};

onMounted(() => {
  window.addEventListener('scroll', checkAffix);
});

onUnmounted(() => {
  window.removeEventListener('scroll', checkAffix);
});

const isDesktop = useDesktop('md');
const $router = useRouter();
const selectedIndex = ref(0);
let isClick = false;
const $route = useRoute();
const options = [
  { title: 'Top100 DAOs by Treasury', subtitle: '' },
  // { title: 'Top100 DAO', subtitle: 'By Treasury' },
  { title: 'Top100 DAOs by Governance', subtitle: '' },
  // { title: 'Top100 DAO', subtitle: 'By Governance' },
  {
    title: 'DAO Infrastructure & Tool of the Year',
    subtitle: '',
  },
  // { title: 'Infrastructure & Tool', subtitle: 'Empower industry development' },
  { title: 'DAO People of the Year', subtitle: '' },
  // { title: 'Person of the Year', subtitle: 'DAO Core Contributors' },
  {
    title: 'New Frontier DAO Pioneers',
    subtitle: '',
  },
  // { title: 'New Frontier DAO', subtitle: 'Trailblazers in Emerging Fields' },
];

const textList = [
  {
    titleText: 'Top100 DAOs by Treasury:',
    mainText:
      "In the Top 100 DAOs by Treasury, DAOBase rigorously ranks organizations based on their treasury value, offering a clear snapshot of financial health and resource management within the DAO landscape, with top 100 DAOs occupying $31B, or 98.37% of total DAOs. This list is meticulously compiled using a normalized cross-sectional treasury value of all DAOs listed on DAOBase as of December 31, 2023. This category not only showcases the financial robustness of leading DAOs but also serves as a crucial indicator of their ability to fund initiatives, manage assets, and sustain long-term growth. It's a vital benchmark for understanding the economic power and stability of DAOs in the decentralized world.",
    formulaText:
      'Normalized Value (Treasury) = 100 * ((value - min)/(max - min))',
    endText:
      'value: the original value from data set; min: The minimum value; max: The maximum value.',
  },
  {
    titleText: 'Top 100 DAOs by Governance:',
    mainText:
      'Top 100 DAOs by Governance is a vital measure of active community engagement and effective decision-making within the DAO ecosystem, led by PancakeSwap(99.60),Lenster Polls(99.23),and Decentraland DAO(99.10). This ranking is meticulously crafted based on a comprehensive analysis of proposal numbers and voter participation (including individual voters and delegators) within each DAO over the year 2023. By normalizing and equally weighting these figures, DAOBase provides a holistic view of governance activity, excluding any meaningless proposals to ensure accuracy. This category not only highlights the DAOs with the most dynamic and participative governance structures but also emphasizes the importance of active community involvement and transparent decision-making in driving the success and evolution of DAOs.',
    formulaText:
      'Gov metric = (Normalized No. Proposal + Normalized No. Voter)/2\nNormalized Value (No. Proposl or No. Voter) = arctan(value/(value.quantile(0.5)+0.1)) / π * 200',
  },
  {
    titleText: 'DAO Infrastructure & Tool of the Year:',
    mainText:
      'DAO Infrastructure & Tool of the Year is a celebration of innovation and technological advancement within the DAO sphere. This segment spotlights the essential infrastructure and tools that have significantly bolstered the development and operational efficiency of DAOs in 2023. It encompasses a diverse range of solutions, including blockchain platforms, data analytics, fundraising mechanisms, governance frameworks, identity verification systems, membership models, project management tools, social networking integrations, and treasury management systems. This award recognizes the pivotal role these technologies play in enhancing the functionality, scalability, and impact of DAOs, underscoring their contribution to the evolving landscape of decentralized organizations.',
  },
  {
    titleText: 'DAO People of the Year: ',
    mainText:
      'DAO People of the Year segment is a prestigious acknowledgment of exceptional individuals who have made significant contributions to the DAO community in 2023. This category focuses on honoring leaders, innovators, and active participants within the DAO ecosystem. These individuals may range from founders and core team members to dynamic community contributors. Their recognition stems from their outstanding leadership, innovative solutions, and active engagement in advancing DAOs. This award highlights the human element behind DAOs, celebrating the dedication, creativity, and influence of individuals who are driving the growth and success of decentralized autonomous organizations, and by extension, shaping the future of decentralized governance and collaboration.',
  },
  {
    titleText: 'New Frontier DAO Pioneers: ',
    mainText:
      'New Frontier DAO Pioneers is a distinctive recognition of emerging DAOs that are making significant strides in their respective niches. This segment focuses on honoring innovative and influential early-stage DAOs that emerged in 2023, showcasing their impact and dedication despite being relatively new in the decentralized ecosystem. These pioneering DAOs cover a diverse range of fields such as philanthropy, decentralized science (DeSci), women-led initiatives, investment, media, regenerative finance (ReFi), and service-oriented projects. The recognition of these New Frontier DAO Pioneers serves to highlight the fresh perspectives and novel approaches they bring to the DAO landscape, emphasizing their potential to inspire change, foster community engagement, and drive the evolution of decentralized organizational models.',
  },
];

const selectTab = (index) => {
  selectedIndex.value = index;
};

onMounted(() => {
  const type = $route.params?.type?.toLowerCase();

  if (type === 'bytreasury') {
    selectedIndex.value = 0;
  } else if (type === 'bygovernance') {
    selectedIndex.value = 1;
  } else if (type === 'infrastructure') {
    selectedIndex.value = 2;
  } else if (type === 'personoftheyear') {
    selectedIndex.value = 3;
  } else if (type === 'newfrontierdao') {
    selectedIndex.value = 4;
  }

  watch(
    () => [selectedIndex.value],
    () => {
      $router.push({
        name: 'Dao 100',
        params: {
          type:
            selectedIndex.value === 0
              ? 'byTreasury'
              : selectedIndex.value === 1
              ? 'byGovernance'
              : selectedIndex.value === 2
              ? 'infrastructure'
              : selectedIndex.value === 3
              ? 'personOfTheYear'
              : selectedIndex.value === 4
              ? 'newFrontierDao'
              : '',
        },
      });
    },
  );
});
</script>
<style>
.sidebar {
  animation: fadeInAnimation ease 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fadeInAnimation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.sidebar_exit {
  animation: fadeOutAnimation ease 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes fadeOutAnimation {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.el-dropdown-menu__item--divided {
  --el-border-color-lighter: rgba(255, 255, 255, 0.1);
  margin: 0;
}
.sticky-wrapper {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 0;
}

.absolute-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1; /* Behind the content */
}
.option {
}
.option:hover {
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}
.option_selected {
  --el-border-radius-base: 8px;
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}
</style>
